// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"79d25b2c","513":"5157a0ea","787":"d79c3e8e"}[chunkId] + ".chunk.js";
};